.nest-shell-navigation {
  @apply h-[64px] fixed bottom-[calc(100vh-theme(spacing.16))] left-0 right-0 top-0 bg-white border-b z-10;

  img {
    @apply w-8 h-8 rounded;
  }

}
